import { createSlice } from "@reduxjs/toolkit";
import { faculties } from "../../../types/core_ibass";

export const allFaculties = createSlice({
  name: "all_faculties",
  initialState: {
    value: {
      status: false,
      pagination: [] as {
        pagination_data: {
          current_page: number;
          last_page: number;
          per_page: number;
          total: number;
          from: number;
          to: number;
        };
        data: faculties;
      }[],
      data: [] as faculties,
    },
  },
  reducers: {
    update_faculties: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload?.data;
    },
    add_faculty: (state, action) => {
      const {
        id,
        title,
        institution,
        item_site_location,
        hierarchy,
        user_id,
        is_published,
        hits,
        type,
        created_at,
        updated_at,
      } = action?.payload;
      state.value.data = [
        ...state.value.data,
        {
          id,
          title,
          institution,
          item_site_location,
          hierarchy,
          user_id,
          is_published,
          hits,
          type,
          created_at,
          updated_at,
        },
      ];
    },
    addToPaginationHistory: (state, action) => {
      state.value.pagination = [
        ...state.value.pagination,
        {
          pagination_data: action?.payload?.pagination_data,
          data: action?.payload?.data,
        },
      ];
    },
    remove_faculty: (state, action) => {
      const { id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => Number(v.id) === id
      );
      currentArray.splice(currentIndex, 1);
      state.value.data = currentArray;
    },
    replace_faculty: (state, action) => {
      const {
        id,
        title,
        institution,
        item_site_location,
        hierarchy,
        user_id,
        is_published,
        hits,
        type,
        created_at,
        updated_at,
      } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );
      currentArray.splice(currentIndex, 1, {
        id,
        title,
        institution,
        item_site_location,
        hierarchy,
        user_id,
        is_published,
        hits,
        type,
        created_at,
        updated_at,
      });
      state.value.data = currentArray;
    },
    clear_faculties: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  update_faculties,
  add_faculty,
  addToPaginationHistory,
  remove_faculty,
  replace_faculty,
  clear_faculties,
} = allFaculties.actions;

export default allFaculties.reducer;
